import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeOneComponent } from './components/BydBatteryBox/home-one.component';
import { HomeTwoComponent } from './components/RaiOn/home-two.component';
import { HomeThreeComponent } from './components/AboutUs/home-three.component';
import { HomeFourComponent } from './components/home-four/home-four.component';
import { HomeFiveComponent } from './components/WhereToBuy/home-five.component';
import { HomeSixComponent } from './components/Contact/home-six.component';
import { HomeSevenComponent } from './components/Home/home-seven.component';
import { HomeNineComponent } from './components/OnlineServiceCenter/home-nine.component';
import { HomeElevenComponent } from './components/home-eleven/home-eleven.component';
import { HomeTwelveComponent } from './components/home-twelve/home-twelve.component';
import { HomeThirteenComponent } from './components/home-thirteen/home-thirteen.component';
import { BlogDetailsComponent } from './components/blog-details/blog-details.component';
import { PoliticasComponent } from './components/politicas/politicas.component';
import { langGuard, rootRedirectGuard } from './guards/lang.guard';

// Rutas de contenido (sin prefijo de idioma). Se montan como hijas de :lang.
const contentRoutes: Routes = [
    {path: '', component: HomeSevenComponent, data: {
        title: 'EFT-Systems | BYD Battery-Box & energy storage in Europe',
        description: 'EFT-Systems is the official distributor of BYD Battery-Box in Europe: energy storage systems, after-sales service and local technical support in multiple languages.'
    }},
    { path: 'raion', component: HomeTwoComponent, data: {
        title: 'RaiOn | EFT-Systems',
        description: 'Discover RaiOn energy storage solutions distributed by EFT-Systems across Europe.'
    }},
    { path: 'about', component: HomeThreeComponent, data: {
        title: 'About EFT-Systems | BYD Battery-Box distributor',
        description: 'Learn about EFT-Systems, official BYD Battery-Box distributor with local teams across Europe.'
    }},
    {path: 'home-four', component: HomeFourComponent, data: { title: 'EFT-Systems', description: '' }},
    {path: 'news', component: HomeSixComponent, data: {
        title: 'News & Contact | EFT-Systems',
        description: 'Latest news from EFT-Systems and how to contact our local support teams across Europe.'
    }},
    {path: 'Home', component: HomeSevenComponent, data: {
        title: 'EFT-Systems | BYD Battery-Box & energy storage in Europe',
        description: 'EFT-Systems is the official distributor of BYD Battery-Box in Europe: energy storage systems, after-sales service and local technical support.'
    }},
    {path: 'login', component: HomeNineComponent, data: {
        title: 'Online Service Center | EFT-Systems',
        description: 'Access the EFT-Systems online service center.'
    }},
    {path: 'products', component: HomeElevenComponent, data: {
        title: 'Products | BYD Battery-Box | EFT-Systems',
        description: 'Explore the full range of BYD Battery-Box energy storage products distributed by EFT-Systems in Europe.'
    }},
    {path: 'service', component: HomeTwelveComponent, data: {
        title: 'After-Sales Service | EFT-Systems',
        description: 'After-sales service and technical support for BYD Battery-Box from EFT-Systems.'
    }},
    {path: 'home-thirteen', component: HomeThirteenComponent, data: { title: 'EFT-Systems', description: '' }},
    {path: 'trainings', component: BlogDetailsComponent, data: {
        title: 'Trainings | EFT-Systems',
        description: 'Online and live trainings about BYD Battery-Box installation and maintenance by EFT-Systems.'
    }},
    {path: 'politicas/:section', component: PoliticasComponent, data: {
        title: 'Legal information | EFT-Systems',
        description: 'Legal information, privacy policy and terms of EFT-Systems.'
    }},
    {path: 'politicas', component: PoliticasComponent, data: {
        title: 'Legal information | EFT-Systems',
        description: 'Legal information, privacy policy and terms of EFT-Systems.'
    }},

    // Cualquier ruta desconocida dentro de un idioma redirige a su inicio
    // (limpia automáticamente URLs corruptas como /en/[object%20...]).
    {path: '**', redirectTo: ''}
];

// Estructura con prefijo de idioma: /:lang/<ruta>.
// La raíz "/" redirige al idioma del navegador; cualquier URL sin idioma válido
// se reescribe a /en/... (ver langGuard) para preservar enlaces antiguos.
const routes: Routes = [
    { path: '', pathMatch: 'full', canActivate: [rootRedirectGuard], component: HomeSevenComponent },
    { path: ':lang', canActivate: [langGuard], children: contentRoutes }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }